import { h } from "preact";
import { useEffect, useState } from "preact/hooks";
// eslint-disable-next-line import/no-unresolved
import { JSXInternal } from "preact/src/jsx";

interface Props extends JSXInternal.HTMLAttributes<HTMLImageElement> {
    src: string;
    class: string;
}

function MaybeImage({ src, class: cssClass, ...passProps }: Props) {
    const [error, setError] = useState(false);

    useEffect(() => {
        setError(false);
    }, [src]);

    function handleError() {
        setError(true);
    }

    if (error) {
        return null;
    }

    return (
        <img
            class={cssClass}
            src={src}
            onError={handleError}
            {...passProps}/>
    );
}

export default MaybeImage;
